import css from 'styled-jsx/css';

const styles = css.global`.custom-tabs.tabs-container {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 32px 0;
  overflow: hidden;
}

.custom-tabs.tabs-container .tab-item {
  box-sizing: border-box;
  flex: 0 0 46% !important;
  cursor: pointer;
}

#banco-auto-25-banner + .custom-tabs.tabs-container .tab-item {
  flex: 0 0 100% !important;
}

.custom-tabs.tabs-container .tab-item p {
  font-family: 'SantanderText';
  font-size: 18px;
  font-weight: 400;
  line-height: 28px;
  text-align: center;
  color: #222222;
  margin-bottom: 9px;
  transition: color linear 350ms;
  white-space: nowrap;
}

.custom-tabs.tabs-container .tab-item span {
  display: block;
  background-color: #767676;
  height: 1px;
  width: 100%;
  box-sizing: border-box;
  transition: background-color linear 350ms;
}

.custom-tabs.tabs-container .tab-item.active p {
  color: #cc0000!important;
  color: #cc0000;
}

.custom-tabs.tabs-container .tab-item.active span {
  background-color: #cc0000;
  height: 2px;
}

.sf-tabs-scroll .embla__next,
.sf-tabs-scroll .embla__prev {
  display: none !important;
}

#banco-auto-25-banner + .custom-tabs .tab-item p,
#banco-auto-25-banner + #modal-disclaimer + .custom-tabs .tab-item p,
#banco-auto-25-banner + #modal-disclaimer + #backgroudModal + .custom-tabs  .tab-item p,
#banco-auto-25-banner + #modal-disclaimer a,
#banco-auto-25-banner + #modal-disclaimer #text-disclaimer   {
  color: #fff;
}

#banco-auto-25-banner + .custom-tabs,
#banco-auto-25-banner + #modal-disclaimer,
#banco-auto-25-banner + #modal-disclaimer + .custom-tabs,
#banco-auto-25-banner + #modal-disclaimer + #backgroudModal + .custom-tabs
 {
  background-color: #181818;
}



@media (min-width: 576px) {
  #banco-auto-25-banner + .custom-tabs.tabs-container .tab-item,
  .custom-tabs.tabs-container .tab-item {
    flex: 0 0 145px !important;
  }
}

@media (min-width: 992px) {
  .custom-tabs.tabs-container .tab-item p {
    margin-bottom: 10px;
  }

  .custom-tabs.tabs-container {
    padding: 40px 0 48px;
  }
}

@media(max-width: 992px){
  #banco-auto-25-banner + .custom-tabs {
    background-color: #181818;
    justify-content: flex-start;
    overflow: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
    padding-left: 25px;
    padding-right: 25px;
 
    z-index: 9;
    position: relative;
  }
}`;

export default styles;